module.exports = __webpack_public_path__ + "img/banner-eq.5fdcea53.png";